import Cookies from 'js-cookie'

import { AllowedLang, LangNameAttribute } from '@/types/shared'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) =>
  Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language' // no longer stored in cookie, but kept here, so the language logic is in one place
export const getLanguage = (): AllowedLang => localStorage.getItem(languageKey) as AllowedLang
export const setLanguage = (language: AllowedLang) => localStorage.setItem(languageKey, language)
export const cleanLanguage = () => localStorage.removeItem(languageKey)

const languagesKey = 'languages'
export const getLanguages = (): LangNameAttribute => {
  const localValue = Cookies.get(languagesKey)
  if (localValue) {
    return JSON.parse(localValue.toString())
  }

  return {}
}
export const setLanguages = (languages: LangNameAttribute) => Cookies.set(languagesKey, languages)
export const cleanLanguages = () => Cookies.remove(languagesKey)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

const regionKey = 'selected_region'
export const getRegion = () => Cookies.get(regionKey)
export const setRegion = (regionId: string) => Cookies.set(regionKey, regionId)
export const cleanRegion = () => Cookies.remove(regionKey)

// User
const tokenKey = '@facilityup_access_token'
const refreshTokenKey = '@facilityup_refresh_token'

const secureCookieOptions: Cookies.CookieAttributes = {
  sameSite: 'strict',
  secure: window.location.protocol === 'https:',
}

export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token, secureCookieOptions)
export const getRefreshToken = () => Cookies.get(refreshTokenKey)
export const setRefreshToken = (token: string) =>
  Cookies.set(refreshTokenKey, token, secureCookieOptions)
export const removeToken = () => {
  Cookies.remove(tokenKey)
  Cookies.remove(refreshTokenKey)
}
